import styled from '@emotion/styled';
import { colors, Stack } from '@ui-components/neo.tax';

import { KeywordSearch } from '@neo.tax/shared';

export const EmptyStateOuter = styled(Stack)({
  flexGrow: 1,
});

export const EmptyStateInner = styled(Stack)({
  height: '66%',
});

export const Footer = styled(Stack)({
  boxShadow: '0px -4px 8px 0px rgba(0, 0, 0, 0.20)',
  flexShrink: 0,
});

export const ListFooterWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  flexGrow: 1,
  padding: '1rem',
});

export const MenuWrapper = styled(Stack)({
  height: '24rem',
  position: 'relative',
});

export const SearchWrapper = styled(Stack)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1,
  backgroundColor: colors.white,
});

export const StyledKeywordSearch = styled(KeywordSearch)({
  padding: '0.5rem',
});

export const ProjectList = styled(Stack)({
  display: 'block',
  overflowY: 'auto',
  flexGrow: 1,
  marginTop: 65,
});

export const MainContainer = styled(Stack)({
  display: 'flex',
  height: '100%',
});

export const StackFlexShrink = styled(Stack)({
  flexShrink: 0,
});
